import React from 'react'

const LogoOne = () => (
  <svg className="logo logo--one" viewBox="0 0 46 7">
    <path d="M0 7h46V0H0z" fillRule="evenodd" />
  </svg>
)

const LogoTwo = () => (
  <svg className="logo logo--two" viewBox="0 0 46 28">
    <path
      d="M22.715.16C10.257.16.407 9.128.407 22.66v5.032h7.819V22.66c0-7.344 5.42-14.58 14.489-14.58 9.07 0 14.489 7.236 14.489 14.58v5.033h7.819V22.66c0-13.531-10.06-22.5-22.308-22.5"
      fillRule="evenodd"
    />
  </svg>
)

const LogoThree = () => (
  <svg className="logo logo--three" viewBox="0 0 58 235">
    <g fillRule="evenodd">
      <path d="M37.111 226.202c-3.337 0-4.066-2.57-4.536-5.978l-.781-7.078h1.928c5.004 0 7.402 3.932 7.402 8.075 0 3.25-1.564 4.981-4.013 4.981m3.908-13.373c1.565 0 3.232-.157 5.005-.47v-7.71c-2.555.472-5.005.628-7.924.628H25.851c-8.286 0-12.352 4.984-12.352 13.637 0 7.865 4.014 13.216 10.843 13.897v-7.71c-2.972-.262-4.9-2.413-4.9-5.925 0-3.67 1.876-6.03 5.784-6.03h1.46l1.095 9.542c.729 6.505 3.388 11.54 9.747 11.54 5.733 0 9.172-4.564 9.172-10.805 0-5.087-2.032-9.072-5.68-10.594M46.596 180.423l-32.315-12.43v7.973l23.923 8.441v.106l-23.923 8.864v8.18l31.691-12.427c4.379 1.676 5.473 3.091 5.473 6.343 0 .683 0 1.209-.159 2.15h6.048c.207-1.153.312-2.673.312-3.722-.052-6.713-3.126-10.435-11.05-13.478M30.7 155.672h-1.096c-6.201 0-10.216-2.937-10.216-8.023 0-5.245 4.275-8.287 10.738-8.287 6.567 0 10.79 3.042 10.79 8.287 0 5.086-4.015 8.023-10.216 8.023zm15.323-.052h-5.055c3.179-1.572 5.784-5.402 5.784-10.279 0-8.339-6.723-14.055-16.626-14.055-9.799 0-16.627 5.716-16.627 14.055 0 4.981 2.764 8.655 5.941 10.122H0v8.075h46.023v-7.918zM14.281 125.363h31.743v-8.023H31.325c-6.88 0-10.216-4.092-10.216-9.02 0-.997.052-2.15.209-3.095h-7.35c-.209.735-.26 1.572-.26 2.413 0 4.561 2.761 8.285 7.662 9.806H14.28v7.92zM26.894 95.526c-4.898-.89-7.453-3.724-7.453-7.92 0-4.876 3.492-7.131 7.453-7.131v15.051zm9.279-22.55v7.446c3.022 1.05 4.742 3.305 4.742 6.975 0 4.983-3.231 7.866-8.808 8.391v-22.97H29.5c-8.39 0-16.001 4.772-16.001 14.789 0 8.968 6.306 15.943 16.73 15.943 10.373 0 16.522-6.817 16.522-16.153 0-7.29-3.804-13.006-10.58-14.42zM37.111 60.55c-3.337 0-4.066-2.57-4.536-5.98l-.781-7.079h1.928c5.004 0 7.402 3.932 7.402 8.13 0 3.198-1.564 4.928-4.013 4.928m3.908-13.373c1.565 0 3.232-.158 5.005-.472v-7.71c-2.555.474-5.005.63-7.924.63H25.851c-8.286 0-12.352 4.982-12.352 13.635 0 7.868 4.014 13.216 10.843 13.897v-7.708c-2.972-.261-4.9-2.413-4.9-5.927 0-3.67 1.876-6.03 5.784-6.03h1.46l1.095 9.544c.729 6.503 3.388 11.538 9.747 11.538 5.733 0 9.172-4.563 9.172-10.75 0-5.14-2.032-9.179-5.68-10.647M46.024 23.79h-9.851l-3.598-3.724 13.449-10.49V.296L27.52 14.455 14.28.925v9.281L27.885 23.79H0v8.023h46.024z" />
    </g>
  </svg>
)

class Logo extends React.Component {
  render() {
    return (
      <div className="flex flex-col">
        <div className="relative pin-l-2 lg:pin-l-4">
          <LogoThree />
        </div>
        <div className="overflow-y-hidden my-3px lg:my-1">
          <LogoTwo />
        </div>
        <div>
          <LogoOne />
        </div>
      </div>
    )
  }
}

export default Logo
